import axios, { AxiosRequestConfig } from 'axios';
import config from '.././Config';
import { getHeaders } from './HeaderService';
import { documentDefinition } from '../types/definitions/Document';

const getImageList = async (userId: string, token: string, clientId: string) => {
    const callUrl = `${config.searchApi.imageListGetUrl}/${userId}`;
    const resultImageList = await axios.request({
        method: 'GET',
        url: callUrl,
        headers: getHeaders(token, clientId),
    });
    return resultImageList;
};

const postImageList = async (data: Array<documentDefinition>, userId: string, token: string) => {
    const callUrl = `${config.searchApi.imageListPostUrl}/${userId}`;
    const axconfig = {
        headers: getHeaders(token, ''),
    };
    await axios.post(callUrl, data, axconfig);
};

const deleteImageList = async (data: string[], userId: string, token: string, clientId: string) => {
    const callUrl = `${config.searchApi.imageListDeleteUrl}/${userId}`;
    const axconfig = {
        headers: getHeaders(token, clientId),
    };
    await axios.post(callUrl, data, axconfig);
};

export default {
    getImageList,
    postImageList,
    deleteImageList,
};
